import { WorkingWithUsSectionStyles } from '../section.style';
import { CenterContent, StyleImage } from './benefits-membership.style';
import { ContentBlock } from '@exploration/shared-components';
import { useForceBreakpoint } from '@exploration/ui-utils';

const { Container } = WorkingWithUsSectionStyles;
export interface BenefitsMembershipSectionProps {
  headline: string;
  subHeadline: string;
  content: string[];
  image: {
    alt: string;
    source: {
      publicUrl: string;
    };
  };
}

const BenefitsMembershipSection = ({
  headline,
  subHeadline,
  content,
  image,
}: BenefitsMembershipSectionProps) => {
  Container.defaultProps = {
    forceMobileBreakpoint: useForceBreakpoint() === 'mobile',
  };
  return (
    <Container>
      <ContentBlock
        headline={headline}
        subHeadline={subHeadline}
        checkMarkItems={content}
      />
      <CenterContent>
        <StyleImage
          src={image?.source?.publicUrl}
          alt={image?.alt}
          width={588}
          height={288}
        />
      </CenterContent>
    </Container>
  );
};

export default BenefitsMembershipSection;
